import { combineReducers } from 'redux'
import * as LibReducer from 'dealer-reducers'
import { persistedTableToolsReducer, persistedLayoutReducer } from '../store/persistConfig'
import { ListLayoutReducer, listLayoutReducer } from './listLayoutReducer'
import { LayoutReducer } from './layoutReducer'
import { PaginatedOffersReducer, paginatedOffersReducer } from './paginatedOffersReducer'
import { ClientsReducer, clientsReducer } from './clientsReducer'
import { ClientReducer, clientReducer } from './clientReducer'
import { BrandsReducer, brandsReducer } from './brandsReducer'
import { MotorbikesReducer, motorbikesReducer } from './motorbikesReducer'
import { InvoiceReducer, invoiceReducer } from './invoiceReducer'
import { SellContractReducer, sellContractReducer } from './sellContractReducer'
import { ImportDocumentReducer, importDocumentReducer } from './importDocumentReducer'
import { MarketplaceOffersReducer, marketplaceOffersReducer } from './marketplaceOffersReducer'
import { MotorbikeModelsReducer, motorbikeModelsReducer } from './motorbikeModelsReducer'
import { DocumentsReducer, documentsReducer } from './documentsReducer'
import { CaptchaReducer, captchaReducer } from './captchaReducer'
import { ToastState, toastReducer } from './toastReducer'
import { IntegrationsReducer, integrationsReducer } from './integrationsReducer'
import { PromotionsReducer, promotionsReducer } from './promotionsReducer'
import { MobileReferenceReducer, mobileReferenceReducer } from './mobileReferenceReducer'
import { PhotosReducer, photosReducer } from './photosReducer'

export interface RootReducer {
  authReducer: LibReducer.AuthReducer
  offersListReducer: LibReducer.OffersListReducer
  userDataReducer: LibReducer.UserDataReducer
  loaderReducer: LibReducer.LoaderReducer
  tableToolsReducer: LibReducer.TableToolsReducer
  offerReducer: LibReducer.OfferReducer
  menuReducer: LibReducer.MenuReducer
  inAppNotificationsReducer: LibReducer.InAppNotificationsReducer
  homeScreenOffersReducer: LibReducer.HomeScreenOffersReducer
  conversationReducer: LibReducer.ConversationReducer
  conversationsListReducer: LibReducer.ConversationsListReducer
  invoicesListReducer: LibReducer.InvoicesListReducer
  listLayoutReducer: ListLayoutReducer
  layoutReducer: LayoutReducer
  translationsReducer: LibReducer.TranslationsReducer
  paginatedOffersReducer: PaginatedOffersReducer
  clientsReducer: ClientsReducer
  clientReducer: ClientReducer
  brandsReducer: BrandsReducer
  motorbikesReducer: MotorbikesReducer
  invoiceReducer: InvoiceReducer
  sellContractReducer: SellContractReducer
  importDocumentReducer: ImportDocumentReducer
  marketplaceOffersReducer: MarketplaceOffersReducer
  motorbikeModelsReducer: MotorbikeModelsReducer
  documentsReducer: DocumentsReducer
  speditionsReducer: LibReducer.SpeditionsReducer
  captchaReducer: CaptchaReducer
  toastReducer: ToastState
  integrationsReducer: IntegrationsReducer
  promotionsReducer: PromotionsReducer
  mobileReferenceReducer: MobileReferenceReducer
  photosReducer: PhotosReducer
}

const rootReducer = combineReducers({
  authReducer: LibReducer.authReducer,
  userDataReducer: LibReducer.userDataReducer,
  offersListReducer: LibReducer.offersListReducer,
  loaderReducer: LibReducer.loaderReducer,
  tableToolsReducer: persistedTableToolsReducer,
  offerReducer: LibReducer.offerReducer,
  menuReducer: LibReducer.menuReducer,
  inAppNotificationsReducer: LibReducer.inAppNotificationsReducer,
  homeScreenOffersReducer: LibReducer.homeScreenOffersReducer,
  conversationReducer: LibReducer.conversationReducer,
  conversationsListReducer: LibReducer.conversationsListReducer,
  invoicesListReducer: LibReducer.invoicesListReducer,
  translationsReducer: LibReducer.translationsReducer,
  paginatedOffersReducer,
  listLayoutReducer,
  layoutReducer: persistedLayoutReducer,
  clientsReducer,
  clientReducer,
  brandsReducer,
  motorbikesReducer,
  invoiceReducer,
  sellContractReducer,
  importDocumentReducer,
  marketplaceOffersReducer,
  motorbikeModelsReducer,
  documentsReducer,
  speditionsReducer: LibReducer.speditionsReducer,
  captchaReducer,
  toastReducer,
  integrationsReducer,
  promotionsReducer,
  mobileReferenceReducer,
  photosReducer
})

export default rootReducer
